import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { Complaint } from '../types';
import { getIdFromTitle } from './utils';
import * as legacyRecords from 'state/records/types';

export const complaintsAdapter = createEntityAdapter<Complaint>({
  selectId: getIdFromTitle,
});

export const getInitialState = () =>
  complaintsAdapter.getInitialState({ mainComplaint: '' });

const complaintsSlice = createSlice({
  name: 'medicalRecords/currentRecord',
  initialState: getInitialState(),
  reducers: {
    addComplaint: complaintsAdapter.addOne,
    updateComplaint: complaintsAdapter.updateOne,
    removeComplaint: complaintsAdapter.removeOne,
    setMainComplaint: {
      prepare: (title: string) => ({ payload: title.toLowerCase() }),
      reducer: (state, action: PayloadAction<string>) => ({
        ...state,
        mainComplaint: action.payload,
      }),
    },
  },
  extraReducers: {
    [legacyRecords.INITIALIZED]: () => getInitialState(),
  },
});

export const {
  addComplaint,
  updateComplaint,
  removeComplaint,
  setMainComplaint,
} = complaintsSlice.actions;

export default complaintsSlice.reducer;
